export var RADIO_SIZE = {
  xs: '20px',
  md: '22px',
  lg: '24px',
  xl: '28px'
};
export var RADIO_INNER_SIZE = {
  xs: '12px',
  lg: '14px',
  xl: '16px'
};
export var RADIO_LABEL_MARGIN = {
  xs: '6px',
  md: '8px',
  xl: '10px'
};